import { SignUpUserData } from "../../ps-models";
import { CampaignSignUpData, CampaignSignUpPayload } from "../signupViaCampaign.client";

export interface DevelopmentProjectsCampaignSignUpData extends CampaignSignUpData {}

export class DevelopmentProjectsCampaignSignUpPayload extends CampaignSignUpPayload {
constructor(signUpPayload: CampaignSignUpData) {
        signUpPayload.campaign = "development-projects";
        super(signUpPayload);
    }
    get signUpUserData(): SignUpUserData {
        return {
            isNewUser: true,
            providerId: "password",
            profile: {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                displayName: this.displayName,
                campaign: this.campaign,
                userProvidedCompanyName: this.userProvidedCompanyName,
            },
            status: this.status,
        }
    }
}
